module.exports = __webpack_public_path__ + "static/img/19.1f6e07e9.jpg";